import Box from "@mui/material/Box";
import GenericButton from "../../../../shared/ui/GenericButton";
import PageTitle from "../../../../shared/ui/PageTitle";
import {useAuth} from "../../../../hooks/useAuth";
import {Link, useLocation, useNavigate} from "react-router-dom";
import BoxContent from "../../../../shared/ui/BoxContent";
import {useRouteMatch} from "../../../../utils/functions";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import SubcategoriesActive from "../components/SubcategoriesActive";
import SubcategoriesArchived from "../components/SubcategoriesArchived";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const CustomSubcategories = () => {
    const {user} = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const currentTab = useRouteMatch(["/subcategorii-proprii", "/subcategorii-proprii/arhiva"]);

    const theme = useTheme();
    const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));

    const addItemHandler = () => {
        navigate(`/subcategorii-proprii/adauga`);
    };

    return (
        <Box>
            <PageTitle
                actions={
                    user.position === "teacher" ? (
                        <GenericButton
                            type="add"
                            onClick={() => {
                                addItemHandler();
                            }}
                        />
                    ) : (
                        ""
                    )
                }
            >
                Subcategorii proprii
            </PageTitle>
            <BoxContent>
                <>
                    <Box sx={{width: "100%"}}>
                        <Box mb={2} sx={{borderBottom: 1, borderColor: "divider"}}>
                            <Tabs
                                value={currentTab}
                                variant="scrollable"
                                scrollButtons={!isSmUp}
                                allowScrollButtonsMobile
                            >
                                <Tab label="Subcategorii active" value="/subcategorii-proprii" to="/subcategorii-proprii" component={Link}/>
                                <Tab
                                    label="Subcategorii arhivate"
                                    value="/subcategorii-proprii/arhiva"
                                    to="/subcategorii-proprii/arhiva"
                                    component={Link}
                                />
                            </Tabs>
                        </Box>
                        {location.pathname === "/subcategorii-proprii" && <SubcategoriesActive/>}
                        {location.pathname === "/subcategorii-proprii/arhiva" && <SubcategoriesArchived/>}
                    </Box>
                </>
            </BoxContent>
        </Box>
    );
}

export default CustomSubcategories;